/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Auth_Password_Errors_User_Already_In_RoleInputs */

const nl_auth_password_errors_user_already_in_role = /** @type {(inputs: Auth_Password_Errors_User_Already_In_RoleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`De gebruiker heeft deze rol al`)
};

/**

* @param {Auth_Password_Errors_User_Already_In_RoleInputs} inputs
* @param {{ locale?: "nl" }} options
* @returns {LocalizedString}
*/
const auth_password_errors_user_already_in_role = /** @type {((inputs?: Auth_Password_Errors_User_Already_In_RoleInputs, options?: { locale?: "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Auth_Password_Errors_User_Already_In_RoleInputs, { locale?: "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return nl_auth_password_errors_user_already_in_role(inputs)
});
export { auth_password_errors_user_already_in_role as "auth.password_errors.user_already_in_role" }